import { Auth } from "aws-amplify";
import { noshApiRequest } from "./noshApiRequest";
import convertBirthday from "./convertBirthday";

const URL_SERVICE = "https://app.gmo-ekyc.com";

const getToken = async () => {
    const session = await Auth.currentSession();
    const token = session.getAccessToken().getJwtToken();
    return token;
}

const fetchEKycJwt = async () => {
    const token = await getToken();
    const url = "/ekyc/jwt?token=" + token;
    const data = await noshApiRequest(url, "GET", null);
    return data.access_token;
}

const fetchEKcResult = async () => {
    const token = await getToken();
    const url = "/ekyc/result?token=" + token;
    const data = await noshApiRequest(url, "POST", null);
    return data;
}

const fetchSuccessEkycResult = async () => {
    const token = await getToken();
    const url = "/ekyc/result/success?token=" + token;
    const data = await noshApiRequest(url, "GET", null);
    return data;
}

const fetchFailedEkycResult = async () => {
    const token = await getToken();
    const url = "/ekyc/result/failed?token=" + token;
    const data = await noshApiRequest(url, "GET", null);
    return data;
}

const redirectEKyc = async (jwt) => {
    const url = `${URL_SERVICE}/entry/${jwt}`;
    window.location.href = url;
};

export const startEKyc = async () => {
    const jwt = await fetchEKycJwt();
    redirectEKyc(jwt);
}

const updateCognito = async (result) => {
    const {
        auth_result,
        ocr_result,
        address,
        birth_day,
        full_name,
    } = result;
    const noData = result[0];
    if (noData) {
        throw new Error("no_data");
    }
    const isSuccess = auth_result === 0 && ocr_result === 0;
    if (!isSuccess) {
        console.error("failed_to_ekyc");
        throw new Error("failed_to_ekyc");
    }

    const convertedBirthDay = convertBirthday(birth_day);

    const user = await Auth.currentAuthenticatedUser();
    const name = full_name.split(" ");
    const family_name = name ? name[0] : "";
    const given_name = name ? name[1] : "";
    const attr = {
        "custom:isFinishEKyc": "true",
        "custom:ocr_address": address,
        "family_name": family_name,
        "given_name": given_name,
    }
    if (convertedBirthDay) {
        attr["birthdate"] = convertedBirthDay;
    }
    await Auth.updateUserAttributes(user, attr);
}

export const finishEkyc = async () => {
    try {
        const result = await fetchEKcResult();
        await updateCognito(result);
    } catch (e) {
        throw e;
    }
}

export const fetchAndUpdateEkyc = async (user) => {
    try {
        if (user.attributes["custom:isFinishEKyc"] || user.attributes["custom:finish_manual_ekyc"]) {
            return null;
        }
        const result = await fetchSuccessEkycResult();
        if (!result || !result.length) {
            return [];
        }
        const latestResult = result[result.length - 1];
        await updateCognito(latestResult);
        return [];
    } catch (e) {
        throw e;
    }
}

export const fetchFailedEkyc = async (user) => {
    try {
        if (user.attributes["custom:isFinishEKyc"] || user.attributes["custom:finish_manual_ekyc"]) {
            return null;
        }
        const result = await fetchFailedEkycResult();
        if (!result || !result.length) {
            return null;
        }
        const latestResult = result[result.length - 1];
        return latestResult;
    } catch (e) {
        throw e;
    }
}